import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { CommonPagePromo } from 'apps/promo/components/common/CommonPagePromo';
import { LightNavBar } from 'apps/promo/components/common/fromAuth/LightNavBar/LightNavBar';
import LogoPurple from 'apps/promo/components/common/logo-purple/LogoPurple';
import { PromoInfoPage } from 'apps/promo/components/common/PromoInfoPage/PromoInfoPage';
import { LANDING_LINK } from 'apps/promo/constants/UrlConstants';
import { resolveArguments } from 'apps/promo/helpers/utils';

const NotFoundInfo = (props) => {
    const getErrorText = resolveArguments(props.errorText, props.billId);

    return (
        <CommonPagePromo>
            <LightNavBar align="left">
                <LogoPurple />
            </LightNavBar>
            <PromoInfoPage
                animatedIconFail
                headerText={getErrorText}
                primaryButtonCaption={props.homePage}
                primaryButtonType="link"
                primaryButtonLink={LANDING_LINK}
            />
        </CommonPagePromo>
    );
};
const mapStateToProps = (state) => {
    return {
        errorText: state.extra?.strapiApi?.errorText,
        homePage: state.extra?.strapiApi?.homePage,
        billId: state.extra?.strapiApi?.billId,
    };
};
NotFoundInfo.propTypes = {
    errorText: PropTypes.string.isRequired,
    homePage: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(NotFoundInfo);
